import {FC} from "react";

import {TabBlockAside, TabP, TabTitle, TabTitleDark} from "../styles";
import ImgWeakSignals from "../../../assets/images/metodology-weaksignal.svg";
import ImgArrowRight from "../../../assets/images/icon-tab-arrow-toright.svg";
import ImgStep1 from "../../../assets/images/metodology-step1.svg";
import ImgStep2 from "../../../assets/images/metodology-step2.svg";
import ImgStep3 from "../../../assets/images/metodology-step3.svg";
import ImgStep8 from "../../../assets/images/metodology-step8.svg";
import ImgStep7 from "../../../assets/images/metodology-step7.svg";
import ImgWeakSignalsIcon from "../../../assets/images/metodology-weaksignal-icon.svg";

const SidebarInfoFinTech: FC = () => {
  return (
    <div style={{padding: "20px 50px"}}>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
            gap: 20,
          }}
        >
          <div style={{width: "45%"}}>
            <img src={ImgWeakSignals} alt="" width={220} />
          </div>
          <div style={{width: "55%"}}>
            <TabTitle>Зрелость технологического кластера в России</TabTitle>
            <TabP>
              Слабые сигналы представляют собой малозаметные признаки изменений
              технологий и бизнес моделей в FinTech, которые могут оказать
              существенное влияние на отрасль в будущем и стать зрелым трендом. 
            </TabP>
            <TabTitleDark isSmall>
              Для бизнеса слабые сигналы имеют критическое значение по следующим
              причинам:
            </TabTitleDark>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabP style={{margin: "4px 0"}}>
                  1. Конкурентное преимущество
                </TabP>
                <TabP style={{margin: "4px 0"}}>2. Управление рисками</TabP>
                <TabP style={{margin: "4px 0"}}>
                  3. Стратегическое планирование
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <TabTitle>Конкурентное преимущество</TabTitle>
        <TabP>
          Своевременное выявление и реагирование на слабые сигналы позволяет
          компаниям опережать конкурентов в разработке инновационных продуктов и
          услуг.
        </TabP>
      </TabBlockAside>
      <TabBlockAside>
        <TabTitle>Управление рисками</TabTitle>
        <TabP>
          Анализ слабых сигналов помогает идентифицировать потенциальные угрозы
          на ранних стадиях, давая возможность разработать превентивные меры.
        </TabP>
      </TabBlockAside>
      <TabBlockAside>
        <TabTitle>Стратегическое планирование</TabTitle>
        <TabP>
          Понимание зарождающихся трендов позволяет более эффективно формировать
          долгосрочную стратегию развития компании.
        </TabP>
      </TabBlockAside>
      <TabBlockAside>
        <ul>
          <li>
            <TabP>
              Проявляются слабые сигналы от незначительных изменений в поведении
              потребителей финансовых услуг до малозаметных технологических
              инноваций или регуляторных инициатив. 
            </TabP>
          </li>
          <li>
            <TabP>
              Идентификация и анализ слабых сигналов требуют интеграции
              современных методов обработки данных, экспертного подхода и
              детального понимания процессов, характерных для финтех-отрасли.
            </TabP>
          </li>
          <li>
            <TabP>
              В условиях ускоряющихся технологических изменений и повышенной
              неопределенности способность улавливать малозаметные, но значимые
              сигналы становится решающим условием для компаний, стремящихся не
              только адаптироваться к новым реалиям, но и активно влиять на их
              формирование.
            </TabP>
          </li>
        </ul>
      </TabBlockAside>
      <TabTitleDark>Методология</TabTitleDark>
      <br />
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={60} src={ImgStep1} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 1</TabTitle>
            <TabP>
              Определение технологических направлений (сегментов) на основе
              анализа стратегических документов России и мира.
            </TabP>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={60} src={ImgStep3} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 2</TabTitle>
            <TabP>
              С помощью ИИ модели выполнялась саммаризация текстов таким
              образом, чтобы в саммари упоминались ключевые технологии и бизнес
              модели, если они есть.
            </TabP>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={60} src={ImgStep8} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 3</TabTitle>
            <TabP>
              Обученный ИИ классификатор оставлял новости, в которых упоминаются
              коммерческие кейсы внедрения финансовыми организациями или
              стартапами технологий.
            </TabP>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={60} src={ImgStep2} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 4</TabTitle>
            <TabP>
              ИИ модель поиска выбросов ранжировала новости по "удаленности" от
              основной массы новостей, чтобы присвоить больший приоритет
              нестандартным кейсам.
            </TabP>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={60} src={ImgStep7} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 5</TabTitle>
            <TabP>
              Экспертным образом описание саммари новости дополнялось описанием
              продукта с веб сайта упоминаемой компании-поставщика.
            </TabP>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={60} src={ImgWeakSignalsIcon} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 6</TabTitle>
            <TabP>
              Из саммари экспертным образом выделялась суть слабого сигнала на
              основе кейса.
            </TabP>
          </div>
        </div>
      </TabBlockAside>
    </div>
  );
};

export default SidebarInfoFinTech;
